import { Controller } from "@hotwired/stimulus"

// Board-level loading indicator for capacity-planning mutations. Mounted on #planning_board, it
// counts in-flight requests via the document `planning:busy` / `planning:idle` events dispatched by
// planningMutation, and while any request is pending it reveals a thin animated progress bar at the
// top of the board and marks the board `aria-busy`. The counter (not a boolean) keeps the bar up
// when several edits overlap and only clears it once the last one settles.
export default class extends Controller {
  static targets = ["bar"]

  connect() {
    this.count = 0
    this.boundBusy = this.busy.bind(this)
    this.boundIdle = this.idle.bind(this)
    document.addEventListener("planning:busy", this.boundBusy)
    document.addEventListener("planning:idle", this.boundIdle)
  }

  disconnect() {
    document.removeEventListener("planning:busy", this.boundBusy)
    document.removeEventListener("planning:idle", this.boundIdle)
  }

  busy() {
    this.count += 1
    this.render()
  }

  idle() {
    this.count = Math.max(0, this.count - 1)
    this.render()
  }

  render() {
    const active = this.count > 0
    this.element.setAttribute("aria-busy", active ? "true" : "false")
    if (this.hasBarTarget) this.barTarget.classList.toggle("hidden", !active)
  }
}
